<template>
  <div>
    <div v-if="profiles && profiles.length">
      <v-card class="pa-3 hyp-risk-seerist-swirl hyp-risks-content-expanded">
        <div class="hyp-risk-content-container">
          <div>
            <span
              class="details-heading application-heading pull-left pl-3 mr-3"
              >Profile</span
            >
            <v-select
              v-model="profileSelectedId"
              :items="profiles"
              item-text="name"
              item-value="name"
              :width="200"
              hide-details
              class="pull-right pt-0 mr-2 profile-types"
            ></v-select>
            <div class="clearfix"></div>
          </div>
          <div
            v-if="profileSelected && profileSelected.body"
            ref="bodyProfile"
            v-html="getCleanBody(profileSelected.body)"
            class="pt-3 content-container"
          ></div>
        </div>
      </v-card>
    </div>
    <v-row v-if="!profiles || profiles.length < 1">
      <v-col cols="12">
        We do not currently provide profile on this country. Please
        <a :href="`mailto:${SUPPORT_EMAIL}`">contact our team</a> if you are
        interested.
      </v-col>
    </v-row>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";

import { addTargetToLinks } from "@/common/basic.utilities";
import { COUNTRY_PROFILES } from "@/common/constants/controlRisks/risks";
import { SUPPORT_EMAIL } from "@/common/constants/misc";

export default {
  name: "RisksProfiles",
  components: {},
  props: {
    background: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      profileSelectedId: COUNTRY_PROFILES.political.name,
    };
  },
  created() {
    this.SUPPORT_EMAIL = SUPPORT_EMAIL;
  },
  computed: {
    profiles() {
      if (lodashGet(this.background, "properties.formatted.profiles.length")) {
        return this.background.properties.formatted.profiles;
      }
      return null;
    },
    profileSelected() {
      if (this.profiles && this.profiles.length && this.profileSelectedId) {
        return lodashFind(this.profiles, ["name", this.profileSelectedId]);
      }
      return null;
    },
  },
  methods: {
    getCleanBody(body) {
      if (body) {
        return addTargetToLinks(body);
      }
      return "";
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 24px;
}
.content-container {
  max-width: unset !important;
  font-size: 14px;
}
.profile-types {
  position: relative;
  top: -10px;
  width: 200px !important;
}
.hyp-risk-content-container {
  max-width: 50vw;
  margin: 12px auto;
}
.hyp-risks-content-expanded {
  min-height: 80vh;
}
</style>
